import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfUse from "../pages/terms/page";
import PartnershipPage from "../pages/Partnership/page";
import SuleimanPage from "../pages/suleyman/page";
import SumeyraPage from "../pages/sumeyra/page";
import HakanKocPage from "../pages/hakan_koc/page";

// ... existing code ...

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/partnership",
    element: <PartnershipPage />,
  },
  {
    path: "/suleyman",
    element: <SuleimanPage />,
  },
  {
    path: "/sumeyra",
    element: <SumeyraPage />,
  },
  {
    path: "/hakan_koc",
    element: <HakanKocPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;